<p-toast position="top-center" key="confirm" (onClose)="cancelarMensajeConfirmacion()" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
      <div class="flex flex-column" style="flex: 1">
        <div class="text-center">
          <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
          <h4>{{message.summary}}</h4>
          <p>{{message.detail}}</p>
        </div>
        <div class="grid p-fluid">
          <div class="col-6">
            <button type="button" pButton (click)="cancelarMensajeConfirmacion()" label="Cancelar"
              class="p-button-secondary"></button>
          </div>
          <div class="col-6">
            <button type="button" pButton (click)="confirmarMensaje()" label="Aceptar" class="p-button-success"></button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-toast>
  <p-toast position="top-right" key="msj"></p-toast>
  <p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" acceptLabel="Aceptar" rejectLabel="Cancelar"
    rejectButtonStyleClass="p-button-text">
  </p-confirmDialog>
  <p-confirmDialog [style]="{width: '50vw'}" key="sinInformacionDialog" [baseZIndex]="10000" acceptLabel="Aceptar"
    rejectLabel="Cancelar" rejectButtonStyleClass="p-button-text" styleClass="color-confirmar"
    [rejectVisible]="false"></p-confirmDialog>
  <div class="d-flex justify-content-center">
    <div class="container-fluid" style="width: 98%;">
      <div class="row mt-5">
        <div class="col-md-12">
          <div class="card card-shadow sinborde">
            <div class="card-header sinborde" style="background: none; ">
              <div class="cardicono rounded">
                <i class="pi pi-calendar-plus mt-3" style="font-size: 2rem; color: #fff;"></i>
              </div>
              <header style="left: 11%; top: 5%;">
                <div style="display:inline">Gestión de</div>
                <div style="color:rgb(128, 21, 228);display:inline;" class="ml-3">Bono de Contratacion por Temporada</div>
              </header>
              <div class="row d-flex justify-content-around mt-4">
                <div class="col-md-8">
                  <div class="row d-flex justify-content-around">
                    <div class="col-md-4">
                      <p-dropdown [options]="lstSemanas" autoWidth="false" [style]="{'width':'100%'}"
                        placeholder="Seleccione Semana*" [(ngModel)]="selectedSemana" optionLabel="nom_semana"
                        [showClear]="true">
                        <ng-template let-target pTemplate="item">
                          <div class="ui-helper-clearfix" style="position: relative;height:25px;"
                            pTooltip="{{getTargetDescription(target)}}" tooltipPosition="top">
                            <span style="font-size:14px;float:left;margin-top:4px">{{target.nom_semana}}</span>
                          </div>
                        </ng-template>
                      </p-dropdown>
                      <div *ngIf="selectedSemana!=null">
                        <div class="row">
                          <div class="col-sm-6 text-left texto_verde">Inicio:
                            {{selectedSemana.fec_inicio | date: 'dd/MM/yyyy' }}</div>
                          <div class="col-sm-6 text-right texto_verde">Fin:
                            {{selectedSemana.fec_fin | date: 'dd/MM/yyyy' }}</div>
                        </div>
                      </div>
                    </div>
  
                    
                    <div class="row d-flex col-md-3">
                      <p-dropdown [options]="lstCiudadesPrincipales" autoWidth="false" [style]="{'width':'100%'}"
                        placeholder="Seleccione Ciudad*" [(ngModel)]="selectedCiudad" optionLabel="nombre"
                        [showClear]="true">
                      </p-dropdown>
                    </div>
                    <div class="col-md-2">
                        <button pButton pRipple label="Consultar" class="btn btn-primary" icon="pi pi-filter"
                          (click)="cargarInformacionPersonalPorSemana();" pTooltip="Cargar Información"></button>
                      </div>
                      
                    <div class="col-md-3">
                      <div class="row d-flex justify-content-around">
                        <div class="col-md-9">
                          <p-calendar [(ngModel)]="anio_filtro" view="year" [showIcon]="true" dateFormat="yy"
                            inputId="yearpicker" [style]="{'width':'100%','height':'80%'}"
                            pTooltip="Año de Semanas a Consultar" tooltipPosition="top"></p-calendar>
                        </div>
                        <div class="col-md-3">
                          <button pButton pRipple label="Cargar" class="custom-buttoncargar" icon="pi pi-filter"
                            (click)="cargarListadoDeSemanasAnio_cast(anio_filtro);"
                            pTooltip="Cargar Semanas del Año"></button>
                        </div>
                      </div>
                    </div>
  
                  </div>
                </div>
                <div class="col-md-4">
                  <div class=" row  d-flex justify-content-around">
                    <button pButton pRipple type="button" (click)="abrirModalReportes();" label="Reportes"
                      icon="pi pi-file-excel" iconPos="left" class="custom-button-excel" [style]="{'width':'30%','height':'100%'}"></button>
                  </div>
                  <div>
  
                  </div>
                </div>
              </div>
            </div>
            <div class="card-content">
              <div class="row mt-3">
                <p-table #dt1 [value]="lstBonoTemporada" [tableStyle]="{'min-width': '50rem'}"
                  styleClass="p-datatable-sm p-datatable-striped" [scrollable]="true" scrollHeight="480px"
                  responsiveLayout="scroll"
                  [globalFilterFields]="['nom_completo','puesto','apellido_materno','desc_puesto']"
                  [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,15,20,30,50]" [showCurrentPageReport]="true"
                  [resizableColumns]="false" currentPageReportTemplate=" {first} a {last} de {totalRecords} Registros"
                  [loading]="loading">
                  <ng-template pTemplate="caption">
                    <div class="row">
                      <div class="col-md-6">
                            <div class="row d-flex justify-content-start mt-2 mb-3">
                              <div class="col-md-4 ml-3">
                                <p-button 
                                  styleClass="p-button-raised p-button-primary"
                                  pTooltip="Agregar colaborador"
                                  tooltipPosition="right" (click)="agregarColaborador();"
                                  label="Agregar Bono" icon="pi pi-plus-circle" iconPos="right">
                              </p-button>
                              </div>
                            </div>
                        <div class="row d-flex justify-content-start mt-2 mb-3">
                          <div class="col-md-6 ml-3">
                            <!--button
                              *ngIf="(habilitar_agregar && validarClvOperacion()) || lstColaboradoresBono.length == 0"
                              type="button" class="btn btn-primary form-control" (click)="agregarColaborador();"
                              pTooltip="Agregar colaborador" tooltipPosition="top">
                              Agregar Bono Por Contratacion TA <i class="pi pi-plus-circle"></i>
                            </!--button-->
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2"></div>
  
                      <!-- Aseguramos que el input se ajuste dentro del contenedor flexible -->
                      <div class="col-md-4 d-flex justify-content-end">
                        <span class="p-input-icon-left p-ml-auto">
                          <i class="pi pi-search"></i>
                          <input 
                            pInputText 
                            type="text" 
                            size="35"
                            (input)="applyFilterGlobal($event, 'contains')"
                            placeholder="Buscar Nombre, Apellido Paterno, Puesto"
                          />
                        </span>
                      </div>
                    </div>
                  </ng-template>
  
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="min-width: 250px;" class="text-center" pSortableColumn="nom_completo">Nombre Completo<p-sortIcon field="nombre_completo"></p-sortIcon></th>
                      <th style="min-width: 100px;" class="text-center" pSortableColumn="puesto">Puesto<p-sortIcon field="puesto"></p-sortIcon></th>
                      <th style="min-width: 150px;" class="text-center" pSortableColumn="ciudad">Ciudad<p-sortIcon field="ciudad"></p-sortIcon></th>
                      <th style="min-width: 125px;" class="text-center" pSortableColumn="fec_ingreso">Fecha Ingreso<p-sortIcon field="fec_ingreso"></p-sortIcon></th>
                      <th style="min-width: 100px;" class="text-center" pSortableColumn="num_bono"># de Bono<p-sortIcon field="num_bono"></p-sortIcon></th>
                      <th style="min-width: 100px;" class="text-center" class="text-center" pSortableColumn="sem_pago">Semana<p-sortIcon field="sem_pago"></p-sortIcon></th>
                      <th style="min-width: 100px;" class="text-center" class="text-center" pSortableColumn="anio_pago">Año<p-sortIcon field="anio_pago"></p-sortIcon></th>
                      <th style="min-width: 100px;" class="text-center">Importe</th>
                      <th style="min-width: 150px;" class="text-center">Estatus</th>
                      <th class="text-center" style="min-width: 275px;">Acciones</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-data let-index>
                    <tr>
                      <!-- <td class="text-center" style="color: rgb(37, 152, 20);"><b> {{data.cod_chofer}}</b></td> -->
                      <td class="text-center texto_resaltado"> {{data.nombre_completo}}</td>
                      <td class="text-center texto_resaltado"> {{data.dsc_puesto}}</td>
                      <td class="text-center texto_resaltado"> {{data.dsc_ciudad }}  </td>
                      <td class="text-center" style="color:rgb(128, 21, 228)"> <b>{{data.fec_ingreso}}</b></td>
                      <td class="text-center texto_resaltado"> {{ data.num_bono}} </td>
                      <td class="text-center texto_bk"> {{data.id_semana}}</td>
                      <td class="text-center texto_resaltado" style="color: rgb(28, 99, 230);"> {{data.num_anio}}</td>
                      <td class="text-center texto_resaltado"> {{data.imp_bono|currency}}</td>
                      <td class="text-center texto_bk"> {{data.dsc_estatus}}</td>
                      <td style="min-width: 275px;">
                        <div class="d-flex justify-content-around">
                          <div class="col-2" *ngIf="data.clv_estatus==0||data.clv_estatus==2" >
                            <!-- <button pButton *ngIf="data.clv_estatus==1" (click)="autorizarPago(data);" pTooltip="Autorizar Pago"
                            iconPos="left" class="p-button-success p-button-rounded btn-sm" icon="pi pi-check-circle" tooltipPosition="left" appendTo="body"
                            [disabled]="true"></button> -->
                            <!-- <button pButton *ngIf="data.clv_estatus==2" (click)="autorizarPago(data);" pTooltip="Autorizar Pago"
                            iconPos="left" class="p-button-danger p-button-rounded btn-sm" icon="pi pi-times-circle" tooltipPosition="left" appendTo="body"></button> -->
                            <button pButton
                            (click)="autorizarPago(data);" pTooltip="Autorizar Pago"
                            iconPos="left" class="p-button-primary p-button-rounded btn-sm" icon="pi pi-check-circle" tooltipPosition="left" appendTo="body"
                            [disabled]="!data.clv_type"></button>
                          </div>
                          <div class="col-2" *ngIf="data.clv_estatus==0||data.clv_estatus==1" >
                            <button pButton
                            (click)="CancelPagoMensaje(data);" pTooltip="Cancelar Pago"
                            iconPos="left" class="p-button-warning p-button-rounded btn-sm" icon="pi pi-times" tooltipPosition="left" appendTo="body"
                            [disabled]="!data.clv_type"></button>
                          </div>
                          <div class="col-2">
                            <button pButton (click)="EditarPago(data);" pTooltip="Editar Pago"
                            iconPos="left" class="p-button-rounded btn-sm" icon="pi pi-file-edit" tooltipPosition="left" appendTo="body"></button>
                          </div>
                          <div class="col-2">
                            <button pButton (click)="VerInformacion(data);" pTooltip="Ver Informacion"
                            iconPos="left" class="p-button-rounded btn-sm" icon="pi pi-info-circle" tooltipPosition="left" appendTo="body"></button>
                          </div>
                            
        
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>            
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <p-dialog [resizable]="false" [draggable]="false" [scrollTop]="" [(visible)]="dspCliente"
  [style]="{width: '60vw','height':'600px'}" [transitionOptions]="'0ms'"
  (onHide)="cancelarVentanaModal()">
  <ng-template pTemplate="header">
    {{texto_operacion}}
  </ng-template>
  <ng-template pTemplate="content">
    <div class="card-content ">
      <form class="form_cliente" [formGroup]="agregarBonoContratacionForm">
        <div class="ml-1">
          <div class="row mt-1 d-flex justify-content-start">
            <div class="col-sm-6">
              <span class="title-light">Agregar Bono de Contratacion por Temporada
                <i class="pi pi-cog" style="size: 2rem;">
                </i>
              </span>
            </div>
          </div>
          <div class="row mt-3 align-items-start">
            <div class="col-md-3 mt-3 text-subMenu">
              <div class="input-group-addon">
                <i class="pi pi-user color-icon" style="font-size: 2rem"></i>
                <span class="ml-3 align-self-start"><b>Colaborador</b></span>
              </div>
            </div>
            <div class="col-md-6 text-subMenu">
              <p-dropdown [options]="lstgetColaboradorCiudadAltered" optionLabel="nombre_completo"
              formControlName="chofer" autoWidth="false" [showClear]="false"
              placeholder="Seleccione Colaborador" [style]="{'width':'80%' , 'margin-top': '20px'}"
              optionValue="cod_chofer"
              [filter]="true" filterBy="nombre_completo">
              </p-dropdown>
            </div>
          </div>
          <!-- <div class="row justify-content-md-start mt-2">
            <div class="col-md-1 mt-2 text-center">
                
                  <i class="pi pi-user color-icon mr-3" style="  font-size: 2rem"></i>                                
              
            </div>
            <div class="col-md-3 mt-2 text-center">
              <label class="col-form-label color-font">
                <span class="input-group-addon">
                </span>
                Colaborador
              </label>
            </div>
            <div class="col-md-8">
              <p-dropdown [options]="lstgetColaboradorCiudad" optionLabel="nombre_completo"
                formControlName="chofer" autoWidth="false" [showClear]="false"
                placeholder="Seleccione Colaborador" [style]="{'width':'80%' , 'margin-top': '20px'}"
                optionValue="cod_chofer">
              </p-dropdown>
            </div>
          </div> -->
          <div class="row mt-2 align-items-start">
            <div class="col-md-3 mt-3 text-subMenu">
              <div class="input-group-addon">
                <i class="pi pi-home color-icon" style="font-size: 2rem"></i>
                <span class="ml-3 align-self-start"><b>Ciudad Operación</b></span>
              </div>
            </div>
            <div class="col-md-6 text-subMenu">
              <input type="text" pInputText
                formControlName="ciudad_operacion" autoWidth="false" 
                [style]="{'width':'80%' , 'margin-top': '20px'}">
            </div>
          </div>
          <div class="row mt-2 align-items-start">
            <div class="col-md-3 mt-3 text-subMenu">
              <div class="input-group-addon">
                <i class="pi pi-calendar color-icon" style="font-size: 2rem"></i>
                <span class="ml-3 align-self-start"><b>Fecha de Ingreso</b></span>
              </div>
            </div>
            <!-- <div class="col-md-2"></div> -->
            <div class="col-md-4 text-subMenu">
              <p-calendar
                [appendTo]="'body'"
                formControlName="fec_ingreso"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [showTime]="false"
                [disabled]="valEditAdmin"/>
            </div>
          </div>
          <div class="row mt-2 align-items-start">
            <div class="col-md-3 mt-3 text-subMenu">
              <div class="input-group-addon">
                <i class="pi pi-hashtag color-icon" style="font-size: 2rem"></i>
                <span class="ml-3 align-self-start"><b>Semana de Ingreso</b></span>
              </div>
            </div>
            <!-- <div class="col-md-4 mt-2 text-center">
                <label class="col-form-label color-font">
                  <span class="input-group-addon">
                    <i class="pi pi-user color-icon mr-3" style="  font-size: 2rem"></i>
                  </span>
                  Semana de Ingreso
                </label>
              </div> -->
            <div class="col-md-4 text-subMenu">
              <p-dropdown [options]="lstSemanas" autoWidth="false" [style]="{'width':'100%'}"
                placeholder="Seleccione Semana*" optionValue="id_semana"  optionLabel="nom_semana"
                [showClear]="true" formControlName="id_semana">
              </p-dropdown>
            </div>
          </div>
          <div class="row justify-content-md-start mt-2">
            <div class="col-md-3 mt-3 text-subMenu">
              <div class="input-group-addon">
                <i class="pi pi-calendar color-icon" style="font-size: 2rem"></i>
                <span class="ml-3 align-self-start"><b>Exhibición</b></span>
              </div>
            </div>
            <!-- <div class="col-md"></div> -->
            <div class="col-md-2 text-subMenu">
              <p-dropdown [options]="lstDispersion" autoWidth="false" [style]="{'width':'100%'}"
                placeholder="Seleccione Exhibición*" formControlName="clv_disp" optionLabel="nom_disp"
                [showClear]="true" optionValue="clv_disp" [appendTo]="'body'">
              </p-dropdown>
            </div>
            <div class="col-md"></div>
            <div class="col-md-4 justify-content-end">
              <!-- <button pButton
                label="Calcular Dispersión"
                icon="pi pi-calculator"
                class="p-button-success"
                (click)="calcularDispersion()"
                [disabled]="!this.agregarBonoContratacionForm.valid">
              </button> -->
              <p-button
                styleClass="p-button-raised p-button-success"
                pTooltip="Calcular Dispersión"
                tooltipPosition="right" (click)="calcularDispersion()"
                [disabled]="!this.agregarBonoContratacionForm.valid"
                label="Calcular Dispersión" icon="pi pi-calculator" iconPos="right">
              </p-button>
            </div>
          </div>
          
          
          <!-- --------------fin cambios------------- -->
          <div class="mt-4" *ngIf="detalleDispersion && detalleDispersion.length > 0">
            <h5 class="text-center mb-3">Detalle de Dispersión Calculada - Pagos</h5>
          
            <p-table [value]="detalleDispersion" [responsive]="true" [style]="{'width':'100%'}"
            [loading]="loadingDispColab">
              <ng-template pTemplate="header">
                <tr>
                  <th># Pago</th>
                  <th>Semana</th>
                  <th>Año</th>
                  <th>Importe</th>
                </tr>
              </ng-template>
          
              <ng-template pTemplate="body" let-item>
                <tr>
                  <td class="text-center texto_resaltado">{{ item.num_pago }}</td>
                  <td class="text-center texto_bk">{{ item.id_semana }}</td>
                  <td class="text-center texto_resaltado" style="color: rgb(28, 99, 230);">{{ item.num_anio }}</td>
                  <td class="text-center texto_resaltado">{{ item.num_importe | currency:'USD' }}</td>
                </tr>
              </ng-template>
          
              <ng-template pTemplate="footer">
                <tr>
                  <td colspan="3" class="text-right"><b>Total:</b></td>
                  <td><b>{{ getTotalCiudad() | currency:'USD' }}</b></td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          <div class="row d-flex ">
            <div class="col-md-5  mt-8 justify-content-start">
              
            </div>
            <div class="col-md-3 mt-7 justify-content-center">
              <!-- <button pButton class="btn btn-primary form-control" 
                pTooltip="Almacenar informacion"
                tooltipPosition="right" (click)="guardarInformacionDeColaborador()"
                [disabled]="this.detalleDispersion.length==0||!this.agregarBonoContratacionForm.valid">
                <span class="text-white"> Agregar Bono </span>
                <i class="pi pi-save text-white"></i>
              </button> -->
              <p-button
                styleClass="p-button-raised p-button-primary"
                pTooltip="Almacenar informacion"
                tooltipPosition="right" (click)="guardarInformacionDeColaborador()"
                [disabled]="this.detalleDispersion.length==0||!this.agregarBonoContratacionForm.valid"
                label="Agregar Bono" icon="pi pi-save" iconPos="right">
              </p-button>

            </div>
          </div>
        </div>
      </form>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
      (click)="cancelarVentanaModal()"></button>
  </ng-template>
</p-dialog>
<p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspComentario"
  [style]="{width: '50vw','height':'550px'}" [transitionOptions]="'0ms'"
  (onHide)="cancelarVentanaModal()">
  <ng-template pTemplate="header">
    {{ texto_operacion }}
  </ng-template>
  <ng-template pTemplate="content">
    <div class="card-content">
      <form class="form_cliente" [formGroup]="messageForm" (ngSubmit)="guardartexto()">
        <div class="ml-1">
          <div class="row mt-1 d-flex justify-content-start">
            <div class="col-sm-6">
              <span class="title-light">Conteste a detalle las preguntas
                <i class="pi pi-cog" style="size: 2rem;"></i>
              </span>
            </div>
          </div>
          <div class="row mt-2">
            <p><span style="font-weight: bold; ">¿Cual es el motivo del cambio?</span></p>
          </div>

          <div class=" col-md-12 mt-3 justify-content-center text-center align-items-center">
            <textarea formControlName="respuesta" class="form-control" rows="5"
              placeholder="Escribe tu respuesta aquí" [style]="{'width':'80%', 'margin-top': '20px'}"
              pTooltip="Escribe tu respuesta" tooltipPosition="top"></textarea>
          </div>
          <!-- Información de la última modificación -->
          <div class="row d-flex ">
            <div class="col-md-5  mt-6 justify-content-start">
            </div>
            <div class="col-md-3 mt-7 justify-content-center">
              <button class="btn btn-primary form-control" type="submit" pTooltip="Almacenar información"
                tooltipPosition="right">
                <span class="text-white">Guardar</span>
                <i class="pi pi-save text-white"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
      (click)="cancelarVentanaModal()"></button>
  </ng-template>
</p-dialog>

<!-- fin del imoutn de texto  -->


<!-- pdialod QUE MUESTRA MENSAJE  -->
<p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspVerComentario"
[style]="{width: '50vw','height':'550px'}" [transitionOptions]="'0ms'"
(onHide)="cancelarVentanaModal()">
  <ng-template pTemplate="header">
    Motivo del Cambio Manual
  </ng-template>
  <ng-template pTemplate="content">
    <div class="card-content">
      <form class="form_cliente" [formGroup]="messageForm">
        <div class="ml-1">
          <div class="row mt-1 d-flex justify-content-start">
            <div class="col-sm-6">
              <span class="title-light">Esta Pestaña solo es de Visualizacion*
                <i style="size: 2rem;"></i>
              </span>
            </div>
          </div>
          <div class="row mt-2">
            <p><span style="font-weight: bold; ">El motivo del cambio fue que:</span></p>
          </div>

          <div class=" col-md-12 mt-3 justify-content-center text-center align-items-center">
            <textarea formControlName="respuesta" class="form-control" rows="5"
              [style]="{'width':'80%', 'margin-top': '20px'}" pTooltip="Escribe tu respuesta"
              tooltipPosition="top"> {{messageForm.get('dsc_detalle')?.value }}</textarea>
          </div>
          <!-- Información de la última modificación -->
          <div class="row d-flex ">
            <div class="col-md-5  mt-6 justify-content-start">
              <p><span style="font-weight: bold; ">Última Modificación:</span></p>
              <p style="margin-top: 0px;  color: rgb(181, 17, 50);">
                <b>{{ messageForm.get('nom_ult_mod')?.value }}</b>
              </p>
            </div>
            <div class="col-md-3 mt-7 justify-content-center">

            </div>
          </div>
        </div>
      </form>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
      (click)="cancelarVentanaModal()"></button>
  </ng-template>
</p-dialog>



<p-dialog [resizable]="false" [draggable]="false" [(visible)]="dbsReportes"
[style]="{'width': '70vw','height':'620px'}" [transitionOptions]="'0ms'" styleClass="card-shadow"
(onHide)="cancelarModalReportes()">
  <ng-template pTemplate="header">
    Generar Reporte De Excel
  </ng-template>
  <ng-template pTemplate="content">
    <div class="mt-5">
      <hr class="style-two">
      <div class="row">
        <div style="color: #3161C4" class="col-md-2 mt-2">
          <p  class="texto-pesado"><b>Reporte de bono por contratación TA</b></p>
        </div>
        <div class="col-md-3">
          <p-dropdown [options]="lstSemanasRpt" autoWidth="false" [style]="{'width':'100%'}"
            placeholder="Semana*" [(ngModel)]="selectedSemanaReporte" optionLabel="nom_semana"
            [showClear]="true" [appendTo]="'body'">
            <ng-template let-target pTemplate="item">
              <div class="ui-helper-clearfix" style="position: relative;height:25px;"
                pTooltip="{{getTargetDescription(target)}}" tooltipPosition="top">
                <span style="font-size:14px;float:left;margin-top:4px">{{target.nom_semana}}</span>
              </div>
            </ng-template>
          </p-dropdown>
          <div *ngIf="selectedSemanaReporte!=null">
            <div class="row">
              <div style="color: #2fbd2f" class="col-sm-6 text-left "><b>Inicio:
                  {{selectedSemanaReporte.fec_inicio | date: 'dd/MM/yyyy' }}</b></div>
              <div style="color:  #2fbd2f" class="col-sm-6 text-right "><b>Fin:
                  {{selectedSemanaReporte.fec_fin | date: 'dd/MM/yyyy' }}</b></div>
            </div>
          </div>
        </div>  
        <div class="col-md-2">
          <p-dropdown [(ngModel)]="id_ciudad_principalrpt" 
            [options]="lstCiudadesPrincipales" optionLabel="nombre"  
            [disabled]="dsblstCiudades" optionValue="id"
            placeholder="Filtrar por Ciudad" [showClear]="false" >
          </p-dropdown>
        </div>
        <div class="col-md-3 d-flex justify-content-around">
          <div class="col-md-6">
            <p-calendar [(ngModel)]="anio_filtroRpt" view="year" [showIcon]="true" dateFormat="yy"
              inputId="yearpicker" [style]="{'width':'100%','height':'50px'}"
              pTooltip="Año de Semanas a Consultar" tooltipPosition="top"></p-calendar>
          </div>
          <div class="col-md-4">
            <button pButton pRipple label="Cargar" class="custom-buttoncargar" icon="pi pi-filter"
              (click)="cargarListadoDeSemanasAnio_castRpt(anio_filtroRpt);"
              pTooltip="Cargar Semanas del Año"></button>
          </div>
        </div>

        <div class="col-md ml-2">
          <p-button styleClass="p-button-raised p-button-success" label="Exprotar" icon="pi pi-file-export"
            [style]="{'width':'100%'}" (click)="exportarExcel()" [disabled]="disabledReporte()">
          </p-button>
        </div>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="col-2 text-center">
          <i class="pi pi-spin pi-spinner" *ngIf="loading_reporte1"></i>
        </div>
      </div>
      <div class="row">
        <div style="color: #3161C4" class="col-md-10 mt-2">
          <p  class="texto-pesado"><b>Reporte de Todos los bonos por contratación TA</b></p>
        </div>
        <div class="col-md ml-2">
          <p-button styleClass="p-button-raised p-button-success" label="Exprotar" icon="pi pi-file-export"
            [style]="{'width':'100%'}" (click)="exportarExcelTodosTA()" [disabled]="loading_reporte2">
          </p-button>
        </div>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="col-2 text-center">
          <i class="pi pi-spin pi-spinner" *ngIf="loading_reporte2"></i>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
      (click)="cancelarModalReportes();"></button>
  </ng-template>
</p-dialog>
            
<p-dialog [resizable]="false" [draggable]="false" [scrollTop]="" [(visible)]="dspEditar"
  [style]="{width: '60vw','height':'600px'}" [transitionOptions]="'0ms'"
  (onHide)="cancelarVentanaModal()">
  <ng-template pTemplate="header">
    Editar Mes Año Bono
  </ng-template>
  <ng-template pTemplate="content">
    <div class="card-content ">
      <div class="row mt-2 d-flex justify-content-start">
        <div class="col-sm-6">
          <span class="title-lightEd">Info Bono
            <i class="pi pi-cog" style="size: 2rem;">
            </i>
          </span>
        </div>
        <div class="col-md-6">
          <div class="row d-flex justify-content-end">
            <div class="col-md-4">
              <p-calendar [(ngModel)]="anio_filtroEd" view="year" [showIcon]="true" dateFormat="yy"
                inputId="yearpicker" [style]="{'width':'100%','height':'80%'}"
                pTooltip="Año de Semanas a Consultar" tooltipPosition="top"></p-calendar>
            </div>
            <div class="col-md-3">
              <button pButton pRipple label="Cargar" class="custom-buttoncargar" icon="pi pi-filter"
                (click)="cargarListadoDeSemanasAnio_castEd(anio_filtroEd);"
                pTooltip="Cargar Semanas del Año"></button>
            </div>
          </div>
        </div>
      </div>
      <form class="form_cliente" [formGroup]="editarBonoContratacion">
        <div class="ml-2">
          <div class="row justify-content-md-around ml-2">
            <div class="col-12">
              <!-- colaborador  -->
              <div class="row mt-1 align-items-start">
                <div class="col-md-3 mt-3 text-subMenu">
                  <div class="input-group-addon">
                    <i class="pi pi-user color-icon" style="font-size: 2rem"></i>
                    <span class="ml-3 align-self-start"><b>Colaborador</b></span>
                  </div>
                </div>
                <div class="col-md-6 text-subMenu">
                  <input type="text" pInputText
                    formControlName="nombre_completo" autoWidth="false" 
                    [style]="{'width':'80%' , 'margin-top': '20px'}">
                </div>
              </div>
              <div class="row mt-1 align-items-start">
                <div class="col-md-3 mt-3 text-subMenu">
                  <div class="input-group-addon">
                    <i class="pi pi-money-bill color-icon" style="font-size: 2rem"></i>
                    <span class="ml-3 align-self-start"><b>Monto</b></span>
                  </div>
                </div>
                <div class="col-md-6 text-subMenu">
                    <p-inputNumber 
                      formControlName="imp_bono" 
                      inputId="currency-us" 
                      mode="currency" 
                      currency="USD" 
                      locale="en-US"/> 
                </div>
              </div>
              <div class="row mt-2 align-items-start">
                <div class="col-md-3 mt-3 text-subMenu">
                  <div class="input-group-addon">
                    <i class="pi pi-calendar-times color-icon" style="font-size: 2rem"></i>
                    <span class="ml-3 align-self-start"><b>Semana anterior</b></span>
                  </div>
                </div>
                <div class="col-md-3">
                    <div class="col-md-6 text-subMenu">
                      <input type="text" pInputText
                        formControlName="id_semana_anterior" autoWidth="false" 
                        [style]="{'width':'80%' , 'margin-top': '20px'}">
                    </div>
                </div>
                <div class="col-md-3 mt-3 text-subMenu">
                  <div class="input-group-addon">
                    <i class="pi pi-calendar-times color-icon" style="font-size: 2rem"></i>
                    <span class="ml-3 align-self-start"><b>Año anterior</b></span>
                  </div>
                </div>
                <div class="col-md-3 text-subMenu">
                  <input type="text" pInputText
                    formControlName="num_anio_anterior" autoWidth="false" 
                    [style]="{'width':'80%' , 'margin-top': '20px'}">
                </div> 
              </div>
              <div class="row mt-2 align-items-start">
                <div class="col-md-3 mt-3 text-subMenu">
                  <div class="input-group-addon">
                    <i class="pi pi-calendar-times color-icon" style="font-size: 2rem"></i>
                    <span class="ml-3 align-self-start"><b>Semana de aplicación(Nueva)</b></span>
                  </div>
                </div>
                <div class="col-md-3 mt-3 text-subMenu" >
                  <p-dropdown [options]="lstSemanasEd" autoWidth="false" [style]="{'width':'100%'}"
                    placeholder="Seleccione Semana*" optionValue="id_semana"  optionLabel="nom_semana"
                    [showClear]="true" formControlName="nueva_semana" [appendTo]="'body'"
                    >
                  </p-dropdown>
                  <div *ngIf="this.editarBonoContratacion.controls['nueva_semana'].valid">
                    <div class="row">
                      <div class="col-sm-6 text-left texto_verde">Inicio:
                        {{selectedSemanaEd.fec_inicio | date: 'dd/MM/yyyy' }}</div>
                      <div class="col-sm-6 text-right texto_verde">Fin:
                        {{selectedSemanaEd.fec_fin | date: 'dd/MM/yyyy' }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 mt-3 text-subMenu">
                  <div class="input-group-addon">
                    <i class="pi pi-calendar-times color-icon" style="font-size: 2rem"></i>
                    <span class="ml-3 align-self-start"><b>Año de aplicación(Nuevo)</b></span>
                  </div>
                </div>
                <div class="col-md-3 text-subMenu">
                  <input type="text" pInputText
                    formControlName="nuevo_anio" autoWidth="false" 
                    [style]="{'width':'80%' , 'margin-top': '20px'}">
                </div> 
              </div>
            </div>
          </div>
        </div>

          <!-- --------------fin cambios------------- -->
        <div class="row d-flex justify-content-center ">
          
          <div class="col-md-4 mt-4">
            <p-button
              styleClass="p-button-raised p-button-success"
              pTooltip="Guardar Bono"
              tooltipPosition="right" type="submit"
              [disabled]="!this.editarBonoContratacion.valid"
              label="Editar Bono" icon="pi pi-save" iconPos="right"
              (click)="guardarInformacionEditarColaborador()">
            </p-button>
            <!-- <button class="btn p-button-success form-control" type="submit"
              pTooltip="Guardar Bono"
              tooltipPosition="right" [disabled]="this.editarBonoContratacion.valid">
              <span class="text-white">Editar Bono</span>
              <i class="pi pi-save text-white"></i>
            </button> -->

          </div>
        </div>
      </form>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
      (click)="cancelarVentanaEditar()"></button>
  </ng-template>
</p-dialog>
<p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspMensaje" 
[style]="{width: '35vw','height':'430px'}"
(onHide)="CancelMensaje()" [transitionOptions]="'0ms'" styleClass="card-shadow">
  <ng-template pTemplate="header">
    Detalle Cancelación
  </ng-template>
  <ng-template pTemplate="content">
    <form class="form_cliente" [formGroup]="messageForm" (ngSubmit)="CancelarPago()">
      
      <div class="row d-flex justify-content-start mt-2">
        <div class="col-md-3">
          <label class="title-light">Colaborador: </label>
        </div>
        <div class="col-md-9">
          <input type="text" pInputText
            formControlName="nombre_completo" autoWidth="false" 
            [style]="{'width':'80%'}">
        </div>
      </div>
      <div class="row pb-2">
        <div class="row d-flex mt-3 ml-1">
          <!-- <label style=" font-weight: bold;" class="title-light">Colaborador: {{this.formcont}}</label> -->
          <textarea rows="5" cols="50" pInputTextarea formControlName="dsc_detalle"
          placeholder="Ingrese Motivo .."></textarea>
        </div>
      </div>
      <div class="mt-2 d-flex justify-content-center">
        <p-button type="submit" styleClass="p-button-raised p-button-success" [disabled]="!messageForm.valid">ACEPTAR</p-button>
      </div>
    </form>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="CancelMensaje();"></button>
  </ng-template>
</p-dialog>
<p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspInfo" 
[style]="{width: '70vw','height':'75vh'}"
(onHide)="CancelInfo()" [transitionOptions]="'0ms'" styleClass="card-shadow">
  <ng-template pTemplate="header">
    Info Bono
  </ng-template>
  <ng-template pTemplate="content">    
    <div class="row d-flex justify-content-start mt-2">
      <div class="col-md-2">
        <label class="title-lightEd">Colaborador: </label>
      </div>
      <div class="col-md-10">
        <input type="text" pInputText
          value="{{colabInfo}}" autoWidth="false" 
          [style]="{'width':'80%'}" [disabled]="true">
      </div>
    </div>
    <div class="row pb-2">
      <div class="row d-flex mt-3 ml-1">
        <p-table [value]="lstInfoColab" [responsive]="true" 
        [style]="{'width':'100%'}" [loading]="loadingDispColab">
            <ng-template pTemplate="header">
              <tr>
                <th>Puesto</th>
                <th>Ciudad OP</th>
                <th>Fecha Ingreso</th>
                <th># Pago</th>
                <th>Semana</th>
                <th>Año</th>
                <th>Importe</th>
                <th>Estatus</th>
              </tr>
            </ng-template>
        
            <ng-template pTemplate="body" let-item>
              <tr>
                <td class="text-center texto_resaltado">{{ item.dsc_puesto }}</td>
                <td class="text-center texto_resaltado">{{ item.dsc_ciudad_hm }}</td>
                <td class="text-center" style="color:rgb(128, 21, 228)">{{ item.dsc_fec_alta }}</td>
                <td class="text-center texto_resaltado">{{ item.num_bono }}</td>
                <td class="text-center texto_bk">{{ item.num_semana }}</td>
                <td class="text-center texto_resaltado" style="color: rgb(28, 99, 230);">{{ item.num_anio }}</td>
                <td class="text-center texto_resaltado">{{ item.imp_bono | currency:'USD' }}</td>
                <td class="text-center texto_bk">{{ item.dsc_estatus }}</td>
              </tr>
            </ng-template>
        
            <ng-template pTemplate="footer">
              <tr>
                <td colspan="6" class="text-right"><b>Total:</b></td>
                <td><b>{{ getTotalDisp() | currency:'USD' }}</b></td>
                <td></td>
              </tr>
            </ng-template>
          </p-table>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="CancelInfo();"></button>
  </ng-template>
</p-dialog>